import { IMarketYoyGrowthExpectation, TMarketYoyGrowthEdits } from '../model/types'

import { getMarketYoyGrowthExpectationKey } from './getMarketYoyGrowthExpectationKey'
import { resolveMarketYoyGrowthEditRecord } from './resolveMarketYoyGrowthEditRecord'

/**
 * Overlays pending edits onto the fetched records. Returns the input array
 * unchanged when there are no edits. Phantom edits (no backing fetched
 * record) are resolved from their `base` and appended at the end.
 */
export const applyMarketYoyGrowthEdits = (
  records: IMarketYoyGrowthExpectation[],
  edits: TMarketYoyGrowthEdits
): IMarketYoyGrowthExpectation[] => {
  if (!Object.keys(edits).length) {
    return records
  }

  const seenKeys = new Set<string>()

  const patched = records.map((record) => {
    const key = getMarketYoyGrowthExpectationKey(record)
    seenKeys.add(key)
    const entry = edits[key]

    return entry ? resolveMarketYoyGrowthEditRecord(entry, record) : record
  })

  const phantomRecords = Object.entries(edits)
    .filter(([key]) => !seenKeys.has(key))
    .map(([, entry]) => resolveMarketYoyGrowthEditRecord(entry, undefined))

  return phantomRecords.length ? [...patched, ...phantomRecords] : patched
}
